module.exports = __webpack_public_path__ + "assets/img/17_942_big.96cf57f1.jpg";